import { jsx as _jsx } from "react/jsx-runtime";
// web/src/rendering/Renderer.tsx
// Recursive dispatcher. Looks up block.component in the registry, applies
// props. Layout components call <Renderer> on their children, so nesting
// works by construction. Unknown components render nothing (warn in dev).
//
// Memoised: a render block is immutable once produced (charts, tables, stat
// cards). Without memoisation every keystroke in the chat input cascades a
// full SVG re-render of every chart in the thread — recharts renders
// hundreds of DOM nodes per chart, the dashboard ships ~8 of them, and the
// effect is visible character-by-character typing lag. Reference equality
// on the `block` prop is sufficient since the producer (zustand stores)
// keeps render blocks stable across unrelated state changes.
import { memo } from "react";
import { registry } from "./registry";
function RendererImpl({ block }) {
    if (!block || typeof block !== "object" || typeof block.component !== "string") {
        return null;
    }
    const Component = registry[block.component];
    if (!Component) {
        if (import.meta.env?.DEV) {
            // eslint-disable-next-line no-console
            console.warn(`[rendering] unknown component: ${block.component}`);
        }
        return null;
    }
    return _jsx(Component, { ...(block.props ?? {}) });
}
export const Renderer = memo(RendererImpl);
